import QRCode from 'qrcode';
import { QRCodeGenerator } from '../../../shared/types';

export class QRCodeGeneratorImpl implements QRCodeGenerator {
  generateJoinURL(gameId: string, baseURL: string): string {
    return `${baseURL}/join?gameId=${gameId}`;
  }

  async generateQRCode(url: string): Promise<string> {
    try {
      const qrCodeDataURL = await QRCode.toDataURL(url, {
        width: 256,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      });
      return qrCodeDataURL;
    } catch (error) {
      console.error('Error generating QR code:', error);
      throw new Error('Failed to generate QR code');
    }
  }
}

export const qrCodeGenerator = new QRCodeGeneratorImpl();